import { mapState } from 'vuex'

export default {
  data () {
    return {
      collapseTalentOptions: [
        {
          id: 'teacher-talent-button',
          text: 'TeacherTalent',
          url: 'https://www.karier.mu/talent/teacher-talent/?utm_source=kariermu&utm_medium=navigation-bar-for-talent',
          target: '_blank',
          event: 'navbar_for_talent_teacher_talent_click'
        },
        {
          id: 'sales-talent-button',
          text: 'SalesTalent',
          url: 'https://www.karier.mu/talent/blast/?utm_source=kariermu&utm_medium=navigation-bar-for-talent',
          target: '_blank',
          event: 'navbar_for_talent_sales_talent_click'
        }
      ]
    }
  },
  computed: {
    ...mapState(['isPrakerja']),
    ...mapState('user', ['isLogin', 'userInfo', 'isTemporarilyFreezeOtpVerification']),
    urlServerImage () {
      return process.env.VUE_APP_URL_SERVER_IMAGE
    },
    adminURL () {
      return process.env.VUE_APP_ADMIN_URL
    },
    prakerjaURL () {
      return process.env.VUE_APP_PRAKERJA_URL
    },
    kariermuRewriteURL () {
      return this.isPrakerja ? process.env.VUE_APP_PRAKERJA_URL : process.env.VUE_APP_URL_REWRITE
    },
    avatar () {
      return this.userInfo.avatar || this.$store.state.storage.avatar
    },
    userName () {
      return this.userInfo.name || this.$store.state.storage.name
    },
    userProfession () {
      return this.userInfo.profession_name || this.$store.state.storage.profession
    },
    query () {
      const params = new URLSearchParams(document.location.search)
      const ref = params.get('ref')
      if (ref) {
        return '?ref=' + ref
      }

      return ''
    },
    isEmailVerified () {
      return this.userInfo.is_email_verified
    },
    isProfileComplete () {
      const { email, name, year_level_id, city, occupation } = this.userInfo

      if (this.userProfession.toLowerCase().includes('murid')) {
        return !!email && !!name && !!year_level_id /* && !!institution */
      } else if (this.userProfession.toLowerCase().includes('guru')) {
        return !!email && !!name /* && !!institution */
      } else if (this.userProfession.toLowerCase().includes('orangtua')) {
        return !!email && !!name
      } else if (this.userProfession.toLowerCase().includes('mahasiswa')) {
        return !!email && !!name /* && !!institution */
      } else if (this.userProfession.toLowerCase().includes('profesional') || this.userProfession.toLowerCase().includes('professional')) {
        return !!email && !!name
      } else if (this.userProfession.toLowerCase().includes('prakerja')) {
        return !!email && !!name && !!city && !!occupation
      } else {
        return false
      }
    }
  },
  methods: {
    validateData (dataParts) {
      if (dataParts.includes('email') && !this.isEmailVerified) {
      } else if (dataParts.includes('account') && !this.isProfileComplete) {
        this.isShowProfileUncompleted = true
      }
    },
    validateRoute (to, dataParts) {
      if (dataParts.includes('account') && !this.isProfileComplete) {
        return ''
      } else {
        return to
      }
    }
  }
}
